import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '@/widgets/app-layout/Layout';
import Home from '@/pages/HomePage';
import TransactionDetails from '@/pages/TransactionDetailsPage';
import BlockDetails from '@/pages/BlockDetailsPage';
import AddressDetails from '@/pages/AddressDetailsPage';
import NotFound from '@/pages/NotFoundPage';
import { ThemeProvider } from '@/app/providers';

const App: React.FC = () => {
    return (
        <ThemeProvider>
            <Router>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/address/:address" element={<AddressDetails />} />
                        <Route path="/tx/:hash" element={<TransactionDetails />} />
                        <Route path="/block/:height" element={<BlockDetails />} />
                        <Route path="/404" element={<NotFound />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Layout>
            </Router>
        </ThemeProvider>
    );
};

export default App;
